import { HttpParams } from '@angular/common/http';
import { QueryList } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';
import { InputComponent } from '../components/input/input.component';

export const createFormData = (event) => {
  let fileList: FileList = event && event.target.files;
  if (fileList && fileList[0]) {
    let file: File = fileList[0];
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return { formData, fileList, file };
  }
  return { formaData: null, fileList: null, file: null }
}

export const clearInput = (id: string) => {
  // @ts-ignore
  const input: HTMLInputElement = document.querySelector('#' + id);
  if (input) {
    input.type = ''
    input.type = 'file'
  }
}


export const formatDate = (dateArray: number[]) => {
  if (dateArray === null) {
    return null;
  }
  dateArray[1] = dateArray[1] - 1;
  const dateMoment = moment(dateArray);
  return dateMoment.format("YYYY-MM-DDTHH:mm:ss");
}

export function buildQueryParamsFromObject<T extends object>(params: T): HttpParams {
  let httpParams = new HttpParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      httpParams = httpParams.set(key, value.toString());
    }
  });

  return httpParams;
}


export function mapInputsToObject(
  inputs: Array<{ modelKey: string; value: any }>
): Record<string, any> {
  const result: Record<string, any> = {};

  for (const input of inputs) {
    const keyPath = input.modelKey;
    const value = input.value;

    if (value !== undefined && value !== null && value !== '') {
      const keys = keyPath.split('.');
      let current = result;

      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value;
        } else {
          if (!(key in current)) {
            current[key] = {};
          }
          current = current[key];
        }
      });
    }
  }

  return result;
}

export function isNullOrEmpty(value: string | null | undefined): boolean {
  return value === null || value === undefined || value === '';
}

export function mapFormTo<T extends object>(target: T, inputs: QueryList<InputComponent>): T {
  const inputValues = inputs.toArray().reduce((acc, input) => {
    if (input.modelKey) {
      let value = input.value;

      if (input.typeText === 'number') {
        const parsed = parseFloat(value);
        value = isNaN(parsed) ? null : parsed;
      }

      acc[input.modelKey] = value;
    }
    return acc;
  }, {} as any);

  return Object.assign(target, inputValues);
}

export const downloadBlobAsFile = (blob: Blob, nombreArchivo: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nombreArchivo;
  link.click();
  window.URL.revokeObjectURL(url);
}




/**
 * 
 */
const ERROR_MESSAGES = {
  required: 'El campo es requerido',
  pattern: 'Formato inválido: {pattern}',
  minlength: 'El campo debe tener al menos {minLength} caracteres',
  maxlength: 'El campo no debe exceder {maxLength} caracteres',
  email: 'El campo debe ser un correo electrónico válido',
  isFloatTwoDecimals: 'El campo debe ser un número con hasta dos decimales',
  isNumber: 'El campo debe ser numérico',
  max: `El valor debe ser menor o igual a {max}`,
  onlyNegative: 'Solo se permiten números negativos',
  isColorHex: 'Longitud: 6 a 7 caracteres.',
  onlySpecialChars: 'Evita solo símbolos'

};

/**
 * Returns an appropriate error message based on the form control's validation state.
 * @param {AbstractControl} control - The form control to check for errors.
 * @param {Object} [customMessages={}] - Optional custom error messages.
 * @returns {string} The error message to display.
 */
export function getErrorMessage(
  control: AbstractControl,
  customMessages: { [key: string]: string } = {}
): string {
  const errors = control.errors;
  if (errors) {
    for (const errorKey in errors) {
      if (errors.hasOwnProperty(errorKey)) {
        const errorValue = errors[errorKey];
        let messageTemplate =
          customMessages[errorKey] ||
          ERROR_MESSAGES[errorKey] ||
          'Error desconocido';

        if (typeof errorValue === 'object') {
          for (const paramKey in errorValue) {
            messageTemplate = messageTemplate.replace(
              `{${paramKey}}`,
              errorValue[paramKey]
            );
          }
        }

        return messageTemplate;
      }
    }
  }
  return '';
}


export function validColorHex(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }
    if (value.length >= 6 && value.length <= 7) {
      return null;
    }
    return { isColorHex: true };

  };
}


export function noOnlySpecialChars(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || typeof value !== 'string') {
      return null;
    }

    // Expresión regular que evalúa si la cadena contiene **solo** caracteres especiales
    const onlySpecialCharsRegex = /^[^a-zA-Z0-9]+$/;

    if (onlySpecialCharsRegex.test(value)) {
      return { onlySpecialChars: true };
    }

    return null;
  };
}

/**
 * @param value string to convert to permalink
 * @returns sanitized string to use as a URL permalink
 */
export function sanitizePermalink(value: string): string {
  const charMap: Record<string, string> = {
    á: "a", é: "e", í: "i", ó: "o", ú: "u",
    ü: "u", ñ: "n",
    Á: "A", É: "E", Í: "I", Ó: "O", Ú: "U",
    Ü: "U", Ñ: "N"
  };

  const sanitized = value
    .split("")
    .map((char) => charMap[char] || char)
    .join("");

  return sanitized
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}